import '../../themes/internal-tools/borderRadius/index.js';
import '../../themes/internal-tools/color/index.js';
import { TextStyleSemanticsAll } from '../../themes/internal-tools/textStyle/textStyle-semantics.js';
import '../../themes/internal-tools/shape/index.js';
import '../../themes/internal-tools/size/index.js';
import '../../themes/internal-tools/borderWidth/index.js';
import { CloseSides } from '../modal/constants.js';
import { NavigationAlignments } from '../sidesheet/constants.js';
import { BorderRadiusSemanticsAll } from '../../themes/internal-tools/borderRadius/borderRadius-semantics.js';
import { BorderWidthSemanticsAll } from '../../themes/internal-tools/borderWidth/borderWidth-semantics.js';
import { SizeSemanticsAll } from '../../themes/internal-tools/size/size-semantics.js';
import { ColorSemanticsAll } from '../../themes/internal-tools/color/color-semantics.js';
import { ShapeSemanticsAll } from '../../themes/internal-tools/shape/shape-semantics.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var InternalToolsOverrides = {
  BorderRadius: _objectSpread({}, BorderRadiusSemanticsAll),
  BorderWidth: _objectSpread({}, BorderWidthSemanticsAll),
  Size: _objectSpread({}, SizeSemanticsAll),
  Colors: _objectSpread({}, ColorSemanticsAll),
  Modal: {
    closeButtonSide: CloseSides.Trailing,
    useHairlineDividers: true
  },
  Sidesheet: {
    navigationAlignment: NavigationAlignments.Trailing
  },
  Shape: _objectSpread({}, ShapeSemanticsAll),
  Typography: {
    TextStyles: _objectSpread({}, TextStyleSemanticsAll)
  }
};

export { InternalToolsOverrides };
